import { render, staticRenderFns } from "./ProfileSteamData.vue?vue&type=template&id=7d71ece9&"
import script from "./ProfileSteamData.vue?vue&type=script&lang=js&"
export * from "./ProfileSteamData.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports